import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

const unwrap = (response) => response?.data?.response ?? response?.data;

const cleanParams = (params = {}) => Object.entries(params).reduce((acc, [key, value]) => {
  if (value === undefined || value === null || value === '' || value === 'all') return acc;
  acc[key] = value;
  return acc;
}, {});

const MessagingService = {
  async fetchChannels() {
    const response = await axios.get(`${API_URL}/messaging/channels`, header());
    return unwrap(response) || [];
  },

  async saveChannel(payload) {
    const response = await axios.post(`${API_URL}/messaging/channels`, payload, header());
    return unwrap(response);
  },

  async fetchConversations(params = {}) {
    const response = await axios.get(`${API_URL}/messaging/conversations`, { ...header(), params: cleanParams(params) });
    return unwrap(response) || [];
  },

  async fetchUnreadCount(params = {}) {
    const response = await axios.get(`${API_URL}/messaging/unread-count`, { ...header(), params: cleanParams(params) });
    return unwrap(response) || { unread: 0, by_channel_type: {} };
  },

  async fetchMessages(conversationId, params = {}) {
    const response = await axios.get(`${API_URL}/messaging/conversations/${conversationId}/messages`, {
      ...header(),
      params: cleanParams({ limit: 100, ...params })
    });
    return unwrap(response) || [];
  },

  async assignConversation(conversationId, assignedTo) {
    const response = await axios.patch(`${API_URL}/messaging/conversations/${conversationId}/assignment`, { assigned_to: assignedTo || null }, header());
    return unwrap(response);
  },

  async syncNow(channelType = 'all') {
    const response = await axios.post(`${API_URL}/messaging/sync`, { channelType }, header());
    return unwrap(response);
  },

  async sendMessage(conversationId, text) {
    const response = await axios.post(`${API_URL}/messaging/conversations/${conversationId}/messages`, { text }, header());
    return unwrap(response);
  },

  async sendImages(conversationId, files = []) {
    const formData = new FormData();
    files.forEach((file) => formData.append('images', file));
    const authHeader = header();
    const response = await axios.post(`${API_URL}/messaging/conversations/${conversationId}/images`, formData, {
      ...authHeader,
      headers: {
        ...(authHeader.headers || {}),
        'Content-Type': 'multipart/form-data'
      }
    });
    return unwrap(response) || [];
  },

  async sendProducts(conversationId, products = []) {
    const response = await axios.post(`${API_URL}/messaging/conversations/${conversationId}/products`, { products }, header());
    return unwrap(response) || [];
  },

  async retryMessage(messageId) {
    const response = await axios.post(`${API_URL}/messaging/messages/${messageId}/retry`, {}, header());
    return unwrap(response);
  },

  async createTestIncoming(channelId, payload = {}) {
    const response = await axios.post(`${API_URL}/messaging/test/incoming`, { channel_id: channelId, ...payload }, header());
    return unwrap(response);
  }
};

export default MessagingService;
